export default {
    apiKey: "AIzaSyA6WxOHZPczfFETwOtiTMXiyIyT7EESHs0",
    authDomain: "cfbs-dd892.firebaseapp.com",
    databaseURL: "https://cfbs-dd892.firebaseio.com",
    projectId: "cfbs-dd892",
    storageBucket: "cfbs-dd892.appspot.com",
    messagingSenderId: "348000091084",
    appId: "1:348000091084:web:149fddb66749558e"
}
